import { Menu } from '@mantine/core';
import { useIntl } from 'react-intl';
import { PiGear } from 'react-icons/pi';
import {
  BaseCard,
  CardContent,
  CardMainContent,
  CardInfoColumn,
  CardActionColumn,
  CardTitle,
  CardInfoRow,
  CardActions,
} from '@jadwalh/ui';

export interface WorkflowCardProps {
  record: {
    id: number;
    name: string;
    trigger?: string;
    action?: string;
  };
  permissions: string[];
  openMenuId: number | null;
  setOpenMenuId: (id: number | null) => void;
  onEdit: (id: number) => void;
  onDuplicate: (id: number) => void;
  onDelete: (id: number) => void;
}

export const WorkflowCard = ({
  record,
  permissions,
  openMenuId,
  setOpenMenuId,
  onEdit,
  onDuplicate,
  onDelete,
}: WorkflowCardProps) => {
  const { formatMessage } = useIntl();
  const menuOpened = openMenuId === record.id;

  return (
    <BaseCard key={record.id}>
      <CardContent>
        <CardMainContent>
          <CardTitle>{record.name}</CardTitle>
        </CardMainContent>
        <CardInfoColumn>
          {record.trigger && (
            <CardInfoRow>
              <span className="card-details-text">
                {formatMessage({ id: 'reason' })}: {record.trigger}
              </span>
            </CardInfoRow>
          )}
          {record.action && (
            <CardInfoRow>
              <span className="card-details-text">
                {formatMessage({ id: 'TheProcedure' })}: {record.action}
              </span>
            </CardInfoRow>
          )}
        </CardInfoColumn>
        <CardActionColumn>
          <CardActions>
          <Menu
            width={150}
            opened={menuOpened}
            onChange={(opened) => {
              setOpenMenuId(opened ? record.id : null);
            }}
            withinPortal
            zIndex={9999}
            position="bottom-end"
            offset={5}
          >
            <Menu.Target>
              <div className="dots-menu-btn">
                <PiGear />
                <span>
                  {formatMessage({
                    id: 'actions',
                    defaultMessage: 'إجراءات',
                  })}
                </span>
              </div>
            </Menu.Target>
            <Menu.Dropdown>
              {Array.isArray(permissions) &&
                permissions.includes('workflows.update') && (
                  <Menu.Item
                    onClick={() => {
                      setOpenMenuId(null);
                      onEdit(record.id);
                    }}
                  >
                    {formatMessage({ id: 'edit' })}
                  </Menu.Item>
                )}
              {Array.isArray(permissions) &&
                permissions.includes('workflows.duplicate') && (
                  <Menu.Item
                    onClick={async () => {
                      setOpenMenuId(null);
                      await onDuplicate(record.id);
                    }}
                  >
                    {formatMessage({ id: 'repeat' })}
                  </Menu.Item>
                )}
              {Array.isArray(permissions) &&
                permissions.includes('workflows.destroy') && (
                  <Menu.Item
                    onClick={() => {
                      setOpenMenuId(null);
                      onDelete(record.id);
                    }}
                  >
                    {formatMessage({ id: 'delete' })}
                  </Menu.Item>
                )}
            </Menu.Dropdown>
          </Menu>
          </CardActions>
        </CardActionColumn>
      </CardContent>
    </BaseCard>
  );
};
